import styled from '@emotion/styled';

import Checkbox from '@/components/Checkbox/Checkbox';
import ThreeDots from '@/images/ThreeDotsBlack.svg';
import { MouseEventHandler, ReactNode } from 'react';

const HoverContainer = styled.div<{ show: boolean }>`
    display: ${({ show }) => (show ? 'block' : 'none')};
    position: absolute;
    border-radius: 0.7rem 0.7rem 0 0;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgb(255 255 255 / 0.5);
`;

const OptionsButtonWrapper = styled.div`
    position: absolute;
    right: 0;
    top: 0;
    height: 4rem;
    width: 4rem;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
`;

const ThreeDotsCircle = styled.div<{ src: string }>`
    background-image: url(${props => props.src});
    background-repeat: no-repeat;
    background-position: center;
    display: flex;
    background-color: #fff;
    width: 3rem;
    height: 3rem;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    border: 1px solid ${({ theme }) => theme.colors.black[200]};
`;

const CheckboxContainer = styled.div`
    position: absolute;
    top: 1rem;
    left: 1rem;
`;

interface Props extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    onDotsClick?: MouseEventHandler<HTMLDivElement>;
    show: boolean;
    dropdown?: ReactNode;
    children?: ReactNode;
    className?: string;
    isSelected?: boolean;
    onItemSelect?: () => void;
    withCheckbox?: boolean;
    disableSelect?: boolean;
}

function LibraryItemHoverOverlay({
    show,
    dropdown,
    className,
    children,
    onDotsClick,
    onItemSelect,
    isSelected,
    withCheckbox,
    disableSelect,
    ...props
}: Props) {
    const showThreeDots = !!onDotsClick && !dropdown;

    return (
        <HoverContainer show={show} className={className} {...props}>
            {children}
            {dropdown}
            {showThreeDots && (
                <OptionsButtonWrapper onClick={onDotsClick}>
                    <ThreeDotsCircle src={ThreeDots} />
                </OptionsButtonWrapper>
            )}
            {withCheckbox && (
                <CheckboxContainer>
                    <Checkbox checked={!!isSelected} onClick={() => onItemSelect?.()} disabled={disableSelect} />
                </CheckboxContainer>
            )}
        </HoverContainer>
    );
}

export default LibraryItemHoverOverlay;
